import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import { HelmetProvider } from "react-helmet-async"

import store from "./store"

const container = document.getElementById("root")
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </Provider>
)
